import React from 'react';
import { useNavigate } from 'react-router-dom';

const Footer: React.FC = () => {
    const navigate = useNavigate();
    const dosomething = (path: string) => {
        console.log(path);
        navigate(path);
    }
    return (
        <footer>
            <nav>
                <ul>
                    <li>
                        {/* PRIVACY POLICY */}
                        <div onClick={() => { dosomething('/privacy-policy') }}>隱私權政策</div>
                    </li>
                    <li>
                        {/* USER AGREEMENT */}
                        <div onClick={() => { dosomething('/user-agreement') }}>用戶協議</div>
                    </li>
                </ul>
            </nav>
        </footer>
    );
};

export default Footer;